var map = {
	"./minimalist-1.jpg": 44371,
	"./minimalist-10.jpg": 97076,
	"./minimalist-11.jpg": 4513,
	"./minimalist-2.jpg": 41889,
	"./minimalist-3.jpg": 48453,
	"./minimalist-4.jpg": 16626,
	"./minimalist-5.jpg": 76762,
	"./minimalist-6.jpg": 66562,
	"./minimalist-7.jpg": 47738,
	"./minimalist-8.jpg": 42728,
	"./minimalist-9.jpg": 17375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37957;